import { render } from "./reviews.vue?vue&type=template&id=34edbb76&scoped=true"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"

import "./reviews.vue?vue&type=style&index=0&id=34edbb76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34edbb76"]])

export default __exports__